import {CONTENT_CATEGORY_PARAMETER, CONTENT_TYPE_TEXT} from '../../constants';

export default {
  id: 'NB_CLIENTS',
  title: 'Come viene calcolato il numero di clienti con cui sono in relazione?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Come depositante francese escluse filiali, la sua offerta le permette di condividere i suoi documenti con un numero limitato di clienti, definito in base all\'offerta scelta.'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: 'Il numero di clienti attivi con cui la vostra azienda ha una relazione è calcolato sommando il numero di clienti francesi a livello di azienda (SIREN) e il numero di clienti non francesi a livello di sede, escludendo OFA e le società partner di OFA (ILG, Actradis, Hiveo, Subclic).'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: 'Prendiamo esempio di una società depositante francese escluse filiali che condivide i propri documenti con i seguenti clienti attivi:'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '1. Azienda francese 12345678900001'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '2. Azienda francese 12345678900002'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '3. Azienda francese 11111111100001'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '4. Azienda Tedesca'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '5. OFA'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: 'Questo depositante è in relazione con 3 Clienti: l\'azienda 123456789, l\'azienda 111111111 e l\'azienda tedesca.'
  }]
};
